// import axios from '../api/axiosInstance';

import axiosInstance from "../axiosIntance";

export const AuthServices =  {

handleLogin : async (values: { email: string; password: string }) => {
  try {
    const res = await axiosInstance.post('/auth/login', values);
    return res.data; 
  } catch (err: any) {
    throw err?.response?.data?.error || err.message;
  }
},

handleSignup : async (values: {  email: string; password: string }) => {
  try {
    const res = await axiosInstance.post('/auth/register', values);
  return res.data;
  } catch (err: any) {
    throw err?.response?.data?.error || err.message;
  }
},

handleEmailSubmit : async (values: { email: string}) => {
  try {
      const res = await axiosInstance.post('/auth/email-login', values );
    return res.data;
  } catch (err: any) {
    console.log(err);
    throw err?.response?.data?.error?.message || err.message;
  }
},
}
